import '../../assets/index55.css';var ce = Object.defineProperty, le = Object.defineProperties;
var se = Object.getOwnPropertyDescriptors;
var Pa = Object.getOwnPropertySymbols;
var di = Object.prototype.hasOwnProperty, mi = Object.prototype.propertyIsEnumerable;
var ui = Math.pow, si = (a, i, e) => i in a ? ce(a, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[i] = e, A = (a, i) => {
  for (var e in i || (i = {}))
    di.call(i, e) && si(a, e, i[e]);
  if (Pa)
    for (var e of Pa(i))
      mi.call(i, e) && si(a, e, i[e]);
  return a;
}, H = (a, i) => le(a, se(i));
var ga = (a, i) => {
  var e = {};
  for (var t in a)
    di.call(a, t) && i.indexOf(t) < 0 && (e[t] = a[t]);
  if (a != null && Pa)
    for (var t of Pa(a))
      i.indexOf(t) < 0 && mi.call(a, t) && (e[t] = a[t]);
  return e;
};
import { jsx as d, jsxs as ea, Fragment as de } from "react/jsx-runtime";
import me, { useMemo as ha, useRef as _a, useReducer as ue, useEffect as ya, useCallback as Q, forwardRef as ve, useImperativeHandle as fe, Fragment as xe, cloneElement as ge, useState as Ki } from "react";
import { g as he } from "../../_commonjsHelpers-lRDecupM.js";
import { r as Hi } from "../../index-CcXU3z6b.js";
import { c as be } from "../../create-safe-context-DqDyoPVE.js";
import { f as ei, u as $a, b as ye, B as ti } from "../../factory-ueRxoNOV.js";
import { i as we } from "../../is-element-C00Aie10.js";
import { u as ni } from "../../use-styles-DToiHEa6.js";
import { a as ke } from "../../use-merged-ref-n551Tfbr.js";
import { g as Ui, O as je } from "../../OptionalPortal-sP4Hf4UO.js";
import { c as Yi } from "../../create-vars-resolver-Bzbn9G-G.js";
import { L as De } from "../../Loader-DVuQGvNU.js";
import { O as vi } from "../../Overlay-ClwECLq6.js";
import { T as ze } from "../../Transition-esp-rpzm.js";
import { e as Ee } from "../../get-size-Bc1Pz5yf.js";
import { u as Oe } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { u as Fe } from "../../use-disclosure-Do3DbqlJ.js";
import { ArrowFromBottomFarFAIcon as Ta, XMarkFarFAIcon as Pe, FilePdfFarFAIcon as fi, ImageFarFAIcon as xi, VolumeFarFAIcon as gi, VideoFarFAIcon as hi, FileZipFarFAIcon as bi, FileWordFarFAIcon as yi, FileExcelFarFAIcon as wi, FilePowerPointFarFAIcon as ki, CodeFarFAIcon as ji, FileFarFAIcon as _e } from "../Icons/index.js";
import { Button as Di } from "../Button/index.js";
import { ProgressIndicator as Ha } from "../ProgressIndicator/index.js";
import { F as Ua } from "../../Flex-BcSdq2bJ.js";
import { G as Te } from "../../Group-CbE78j-X.js";
import { S as ba } from "../../Stack-CTaaXTID.js";
import { T as Ea } from "../../Text-B7Ta53Id.js";
function zi(a) {
  return typeof a != "string" ? "" : a.charAt(0).toUpperCase() + a.slice(1);
}
var Vi = { root: "m_6e45937b", loader: "m_e8eb006c", overlay: "m_df587f17" };
const Ei = {
  transitionProps: { transition: "fade", duration: 0 },
  overlayProps: { backgroundOpacity: 0.75 },
  zIndex: Ui("overlay")
}, Ae = Yi((a, { zIndex: i }) => ({
  root: {
    "--lo-z-index": i == null ? void 0 : i.toString()
  }
})), oi = ei((a, i) => {
  const e = $a("LoadingOverlay", Ei, a), Y = e, {
    classNames: t,
    className: r,
    style: c,
    styles: s,
    unstyled: o,
    vars: g,
    transitionProps: w,
    loaderProps: b,
    overlayProps: f,
    visible: F,
    zIndex: L
  } = Y, $ = ga(Y, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "transitionProps",
    "loaderProps",
    "overlayProps",
    "visible",
    "zIndex"
  ]), E = ye(), O = ni({
    name: "LoadingOverlay",
    classes: Vi,
    props: e,
    className: r,
    style: c,
    classNames: t,
    styles: s,
    unstyled: o,
    vars: g,
    varsResolver: Ae
  }), R = A(A({}, Ei.overlayProps), f);
  return /* @__PURE__ */ d(ze, H(A({ transition: "fade" }, w), { mounted: !!F, children: (G) => /* @__PURE__ */ ea(ti, H(A(H(A({}, O("root", { style: G })), { ref: i }), $), { children: [
    /* @__PURE__ */ d(De, A(H(A({}, O("loader")), { unstyled: o }), b)),
    /* @__PURE__ */ d(
      vi,
      H(A(A({}, R), O("overlay")), {
        darkHidden: !0,
        unstyled: o,
        color: (f == null ? void 0 : f.color) || E.white
      })
    ),
    /* @__PURE__ */ d(
      vi,
      H(A(A({}, R), O("overlay")), {
        lightHidden: !0,
        unstyled: o,
        color: (f == null ? void 0 : f.color) || E.colors.dark[5]
      })
    )
  ] })) }));
});
oi.classes = Vi;
oi.displayName = "@mantine/core/LoadingOverlay";
var Aa = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ya, Oi;
function Ce() {
  if (Oi) return Ya;
  Oi = 1;
  var a = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function t(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var s = {}, o = 0; o < 10; o++)
        s["_" + String.fromCharCode(o)] = o;
      var g = Object.getOwnPropertyNames(s).map(function(b) {
        return s[b];
      });
      if (g.join("") !== "0123456789")
        return !1;
      var w = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        w[b] = b;
      }), Object.keys(Object.assign({}, w)).join("") === "abcdefghijklmnopqrst";
    } catch (b) {
      return !1;
    }
  }
  return Ya = r() ? Object.assign : function(c, s) {
    for (var o, g = t(c), w, b = 1; b < arguments.length; b++) {
      o = Object(arguments[b]);
      for (var f in o)
        i.call(o, f) && (g[f] = o[f]);
      if (a) {
        w = a(o);
        for (var F = 0; F < w.length; F++)
          e.call(o, w[F]) && (g[w[F]] = o[w[F]]);
      }
    }
    return g;
  }, Ya;
}
var Va, Fi;
function pi() {
  if (Fi) return Va;
  Fi = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Va = a, Va;
}
var Ga, Pi;
function Gi() {
  return Pi || (Pi = 1, Ga = Function.call.bind(Object.prototype.hasOwnProperty)), Ga;
}
var Ja, _i;
function Re() {
  if (_i) return Ja;
  _i = 1;
  var a = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var i = /* @__PURE__ */ pi(), e = {}, t = /* @__PURE__ */ Gi();
    a = function(c) {
      var s = "Warning: " + c;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch (o) {
      }
    };
  }
  function r(c, s, o, g, w) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in c)
        if (t(c, b)) {
          var f;
          try {
            if (typeof c[b] != "function") {
              var F = Error(
                (g || "React class") + ": " + o + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw F.name = "Invariant Violation", F;
            }
            f = c[b](s, b, g, o, null, i);
          } catch ($) {
            f = $;
          }
          if (f && !(f instanceof Error) && a(
            (g || "React class") + ": type specification of " + o + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in e)) {
            e[f.message] = !0;
            var L = w ? w() : "";
            a(
              "Failed " + o + " type: " + f.message + (L != null ? L : "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, Ja = r, Ja;
}
var Xa, Ti;
function Ie() {
  if (Ti) return Xa;
  Ti = 1;
  var a = Hi(), i = Ce(), e = /* @__PURE__ */ pi(), t = /* @__PURE__ */ Gi(), r = /* @__PURE__ */ Re(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(o) {
    var g = "Warning: " + o;
    typeof console != "undefined" && console.error(g);
    try {
      throw new Error(g);
    } catch (w) {
    }
  });
  function s() {
    return null;
  }
  return Xa = function(o, g) {
    var w = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function f(n) {
      var p = n && (w && n[w] || n[b]);
      if (typeof p == "function")
        return p;
    }
    var F = "<<anonymous>>", L = {
      array: R("array"),
      bigint: R("bigint"),
      bool: R("boolean"),
      func: R("function"),
      number: R("number"),
      object: R("object"),
      string: R("string"),
      symbol: R("symbol"),
      any: Y(),
      arrayOf: G,
      element: T(),
      elementType: N(),
      instanceOf: W,
      node: oa(),
      objectOf: X,
      oneOf: V,
      oneOfType: Z,
      shape: aa,
      exact: C
    };
    function $(n, p) {
      return n === p ? n !== 0 || 1 / n === 1 / p : n !== n && p !== p;
    }
    function E(n, p) {
      this.message = n, this.data = p && typeof p == "object" ? p : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function O(n) {
      if (process.env.NODE_ENV !== "production")
        var p = {}, h = 0;
      function m(j, x, v, y, k, D, B) {
        if (y = y || F, D = D || v, B !== e) {
          if (g) {
            var I = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw I.name = "Invariant Violation", I;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var ia = y + ":" + v;
            !p[ia] && // Avoid spamming the console because they are often not actionable except for lib authors
            h < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + D + "` prop on `" + y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), p[ia] = !0, h++);
          }
        }
        return x[v] == null ? j ? x[v] === null ? new E("The " + k + " `" + D + "` is marked as required " + ("in `" + y + "`, but its value is `null`.")) : new E("The " + k + " `" + D + "` is marked as required in " + ("`" + y + "`, but its value is `undefined`.")) : null : n(x, v, y, k, D);
      }
      var u = m.bind(null, !1);
      return u.isRequired = m.bind(null, !0), u;
    }
    function R(n) {
      function p(h, m, u, j, x, v) {
        var y = h[m], k = _(y);
        if (k !== n) {
          var D = pa(y);
          return new E(
            "Invalid " + j + " `" + x + "` of type " + ("`" + D + "` supplied to `" + u + "`, expected ") + ("`" + n + "`."),
            { expectedType: n }
          );
        }
        return null;
      }
      return O(p);
    }
    function Y() {
      return O(s);
    }
    function G(n) {
      function p(h, m, u, j, x) {
        if (typeof n != "function")
          return new E("Property `" + x + "` of component `" + u + "` has invalid PropType notation inside arrayOf.");
        var v = h[m];
        if (!Array.isArray(v)) {
          var y = _(v);
          return new E("Invalid " + j + " `" + x + "` of type " + ("`" + y + "` supplied to `" + u + "`, expected an array."));
        }
        for (var k = 0; k < v.length; k++) {
          var D = n(v, k, u, j, x + "[" + k + "]", e);
          if (D instanceof Error)
            return D;
        }
        return null;
      }
      return O(p);
    }
    function T() {
      function n(p, h, m, u, j) {
        var x = p[h];
        if (!o(x)) {
          var v = _(x);
          return new E("Invalid " + u + " `" + j + "` of type " + ("`" + v + "` supplied to `" + m + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(n);
    }
    function N() {
      function n(p, h, m, u, j) {
        var x = p[h];
        if (!a.isValidElementType(x)) {
          var v = _(x);
          return new E("Invalid " + u + " `" + j + "` of type " + ("`" + v + "` supplied to `" + m + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(n);
    }
    function W(n) {
      function p(h, m, u, j, x) {
        if (!(h[m] instanceof n)) {
          var v = n.name || F, y = ra(h[m]);
          return new E("Invalid " + j + " `" + x + "` of type " + ("`" + y + "` supplied to `" + u + "`, expected ") + ("instance of `" + v + "`."));
        }
        return null;
      }
      return O(p);
    }
    function V(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), s;
      function p(h, m, u, j, x) {
        for (var v = h[m], y = 0; y < n.length; y++)
          if ($(v, n[y]))
            return null;
        var k = JSON.stringify(n, function(B, I) {
          var ia = pa(I);
          return ia === "symbol" ? String(I) : I;
        });
        return new E("Invalid " + j + " `" + x + "` of value `" + String(v) + "` " + ("supplied to `" + u + "`, expected one of " + k + "."));
      }
      return O(p);
    }
    function X(n) {
      function p(h, m, u, j, x) {
        if (typeof n != "function")
          return new E("Property `" + x + "` of component `" + u + "` has invalid PropType notation inside objectOf.");
        var v = h[m], y = _(v);
        if (y !== "object")
          return new E("Invalid " + j + " `" + x + "` of type " + ("`" + y + "` supplied to `" + u + "`, expected an object."));
        for (var k in v)
          if (t(v, k)) {
            var D = n(v, k, u, j, x + "." + k, e);
            if (D instanceof Error)
              return D;
          }
        return null;
      }
      return O(p);
    }
    function Z(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var p = 0; p < n.length; p++) {
        var h = n[p];
        if (typeof h != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + sa(h) + " at index " + p + "."
          ), s;
      }
      function m(u, j, x, v, y) {
        for (var k = [], D = 0; D < n.length; D++) {
          var B = n[D], I = B(u, j, x, v, y, e);
          if (I == null)
            return null;
          I.data && t(I.data, "expectedType") && k.push(I.data.expectedType);
        }
        var ia = k.length > 0 ? ", expected one of type [" + k.join(", ") + "]" : "";
        return new E("Invalid " + v + " `" + y + "` supplied to " + ("`" + x + "`" + ia + "."));
      }
      return O(m);
    }
    function oa() {
      function n(p, h, m, u, j) {
        return S(p[h]) ? null : new E("Invalid " + u + " `" + j + "` supplied to " + ("`" + m + "`, expected a ReactNode."));
      }
      return O(n);
    }
    function K(n, p, h, m, u) {
      return new E(
        (n || "React class") + ": " + p + " type `" + h + "." + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + u + "`."
      );
    }
    function aa(n) {
      function p(h, m, u, j, x) {
        var v = h[m], y = _(v);
        if (y !== "object")
          return new E("Invalid " + j + " `" + x + "` of type `" + y + "` " + ("supplied to `" + u + "`, expected `object`."));
        for (var k in n) {
          var D = n[k];
          if (typeof D != "function")
            return K(u, j, x, k, pa(D));
          var B = D(v, k, u, j, x + "." + k, e);
          if (B)
            return B;
        }
        return null;
      }
      return O(p);
    }
    function C(n) {
      function p(h, m, u, j, x) {
        var v = h[m], y = _(v);
        if (y !== "object")
          return new E("Invalid " + j + " `" + x + "` of type `" + y + "` " + ("supplied to `" + u + "`, expected `object`."));
        var k = i({}, h[m], n);
        for (var D in k) {
          var B = n[D];
          if (t(n, D) && typeof B != "function")
            return K(u, j, x, D, pa(B));
          if (!B)
            return new E(
              "Invalid " + j + " `" + x + "` key `" + D + "` supplied to `" + u + "`.\nBad object: " + JSON.stringify(h[m], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(n), null, "  ")
            );
          var I = B(v, D, u, j, x + "." + D, e);
          if (I)
            return I;
        }
        return null;
      }
      return O(p);
    }
    function S(n) {
      switch (typeof n) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !n;
        case "object":
          if (Array.isArray(n))
            return n.every(S);
          if (n === null || o(n))
            return !0;
          var p = f(n);
          if (p) {
            var h = p.call(n), m;
            if (p !== n.entries) {
              for (; !(m = h.next()).done; )
                if (!S(m.value))
                  return !1;
            } else
              for (; !(m = h.next()).done; ) {
                var u = m.value;
                if (u && !S(u[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function xa(n, p) {
      return n === "symbol" ? !0 : p ? p["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && p instanceof Symbol : !1;
    }
    function _(n) {
      var p = typeof n;
      return Array.isArray(n) ? "array" : n instanceof RegExp ? "object" : xa(p, n) ? "symbol" : p;
    }
    function pa(n) {
      if (typeof n == "undefined" || n === null)
        return "" + n;
      var p = _(n);
      if (p === "object") {
        if (n instanceof Date)
          return "date";
        if (n instanceof RegExp)
          return "regexp";
      }
      return p;
    }
    function sa(n) {
      var p = pa(n);
      switch (p) {
        case "array":
        case "object":
          return "an " + p;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + p;
        default:
          return p;
      }
    }
    function ra(n) {
      return !n.constructor || !n.constructor.name ? F : n.constructor.name;
    }
    return L.checkPropTypes = r, L.resetWarningCache = r.resetWarningCache, L.PropTypes = L, L;
  }, Xa;
}
var Za, Ai;
function qe() {
  if (Ai) return Za;
  Ai = 1;
  var a = /* @__PURE__ */ pi();
  function i() {
  }
  function e() {
  }
  return e.resetWarningCache = i, Za = function() {
    function t(s, o, g, w, b, f) {
      if (f !== a) {
        var F = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw F.name = "Invariant Violation", F;
      }
    }
    t.isRequired = t;
    function r() {
      return t;
    }
    var c = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: r,
      element: t,
      elementType: t,
      instanceOf: r,
      node: t,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: e,
      resetWarningCache: i
    };
    return c.PropTypes = c, c;
  }, Za;
}
var Ci;
function Se() {
  if (Ci) return Aa.exports;
  if (Ci = 1, process.env.NODE_ENV !== "production") {
    var a = Hi(), i = !0;
    Aa.exports = /* @__PURE__ */ Ie()(a.isElement, i);
  } else
    Aa.exports = /* @__PURE__ */ qe()();
  return Aa.exports;
}
var Le = /* @__PURE__ */ Se();
const P = /* @__PURE__ */ he(Le), $e = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  [
    "docx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  [
    "dotx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template"
  ],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  [
    "potx",
    "application/vnd.openxmlformats-officedocument.presentationml.template"
  ],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  [
    "ppsx",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow"
  ],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  [
    "pptx",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  [
    "sldx",
    "application/vnd.openxmlformats-officedocument.presentationml.slide"
  ],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  [
    "xltx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template"
  ],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function wa(a, i, e) {
  const t = Me(a), { webkitRelativePath: r } = a, c = typeof i == "string" ? i : (
    // If <input webkitdirectory> is set,
    // the File will have a {webkitRelativePath} property
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
    typeof r == "string" && r.length > 0 ? r : `./${a.name}`
  );
  return typeof t.path != "string" && Ri(t, "path", c), Ri(t, "relativePath", c), t;
}
function Me(a) {
  const { name: i } = a;
  if (i && i.lastIndexOf(".") !== -1 && !a.type) {
    const t = i.split(".").pop().toLowerCase(), r = $e.get(t);
    r && Object.defineProperty(a, "type", {
      value: r,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return a;
}
function Ri(a, i, e) {
  Object.defineProperty(a, i, {
    value: e,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
var fa = (a, i, e) => new Promise((t, r) => {
  var c = (g) => {
    try {
      o(e.next(g));
    } catch (w) {
      r(w);
    }
  }, s = (g) => {
    try {
      o(e.throw(g));
    } catch (w) {
      r(w);
    }
  }, o = (g) => g.done ? t(g.value) : Promise.resolve(g.value).then(c, s);
  o((e = e.apply(a, i)).next());
});
const We = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function Be(a) {
  return fa(this, null, function* () {
    return Ia(a) && Ne(a.dataTransfer) ? Ye(a.dataTransfer, a.type) : Ke(a) ? He(a) : Array.isArray(a) && a.every((i) => "getFile" in i && typeof i.getFile == "function") ? Ue(a) : [];
  });
}
function Ne(a) {
  return Ia(a);
}
function Ke(a) {
  return Ia(a) && Ia(a.target);
}
function Ia(a) {
  return typeof a == "object" && a !== null;
}
function He(a) {
  return ai(a.target.files).map((i) => wa(i));
}
function Ue(a) {
  return fa(this, null, function* () {
    return (yield Promise.all(a.map((e) => e.getFile()))).map((e) => wa(e));
  });
}
function Ye(a, i) {
  return fa(this, null, function* () {
    if (a.items) {
      const e = ai(a.items).filter((r) => r.kind === "file");
      if (i !== "drop")
        return e;
      const t = yield Promise.all(e.map(Ve));
      return Ii(Ji(t));
    }
    return Ii(ai(a.files).map((e) => wa(e)));
  });
}
function Ii(a) {
  return a.filter((i) => We.indexOf(i.name) === -1);
}
function ai(a) {
  if (a === null)
    return [];
  const i = [];
  for (let e = 0; e < a.length; e++) {
    const t = a[e];
    i.push(t);
  }
  return i;
}
function Ve(a) {
  if (typeof a.webkitGetAsEntry != "function")
    return qi(a);
  const i = a.webkitGetAsEntry();
  return i && i.isDirectory ? Xi(i) : qi(a, i);
}
function Ji(a) {
  return a.reduce(
    (i, e) => [
      ...i,
      ...Array.isArray(e) ? Ji(e) : [e]
    ],
    []
  );
}
function qi(a, i) {
  var e;
  if (typeof a.getAsFileSystemHandle == "function")
    return a.getAsFileSystemHandle().then((c) => fa(this, null, function* () {
      const s = yield c.getFile();
      return s.handle = c, wa(s);
    }));
  const t = a.getAsFile();
  if (!t)
    return Promise.reject(`${a} is not a File`);
  const r = wa(t, (e = i == null ? void 0 : i.fullPath) != null ? e : void 0);
  return Promise.resolve(r);
}
function Ge(a) {
  return fa(this, null, function* () {
    return a.isDirectory ? Xi(a) : Je(a);
  });
}
function Xi(a) {
  const i = a.createReader();
  return new Promise((e, t) => {
    const r = [];
    function c() {
      i.readEntries(
        (s) => fa(this, null, function* () {
          if (s.length) {
            const o = Promise.all(s.map(Ge));
            r.push(o), c();
          } else
            try {
              const o = yield Promise.all(r);
              e(o);
            } catch (o) {
              t(o);
            }
        }),
        (s) => {
          t(s);
        }
      );
    }
    c();
  });
}
function Je(a) {
  return fa(this, null, function* () {
    return new Promise((i, e) => {
      a.file(
        (t) => {
          const r = wa(t, a.fullPath);
          i(r);
        },
        (t) => {
          e(t);
        }
      );
    });
  });
}
function Qa(a, i) {
  if (a && i) {
    const e = Array.isArray(i) ? i : i.split(",");
    if (e.length === 0)
      return !0;
    const t = a.name || "", r = (a.type || "").toLowerCase(), c = r.replace(/\/.*$/, "");
    return e.some((s) => {
      const o = s.trim().toLowerCase();
      return o.charAt(0) === "." ? t.toLowerCase().endsWith(o) : o.endsWith("/*") ? c === o.replace(/\/.*$/, "") : r === o;
    });
  }
  return !0;
}
var Xe = Object.defineProperty, Ze = Object.defineProperties, Qe = Object.getOwnPropertyDescriptors, Si = Object.getOwnPropertySymbols, at = Object.prototype.hasOwnProperty, it = Object.prototype.propertyIsEnumerable, Li = (a, i, e) => i in a ? Xe(a, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[i] = e, et = (a, i) => {
  for (var e in i || (i = {}))
    at.call(i, e) && Li(a, e, i[e]);
  if (Si)
    for (var e of Si(i))
      it.call(i, e) && Li(a, e, i[e]);
  return a;
}, tt = (a, i) => Ze(a, Qe(i));
const nt = typeof Qa == "function" ? Qa : Qa.default, ot = "file-invalid-type", pt = "file-too-large", rt = "file-too-small", ct = "too-many-files", lt = (a = "") => {
  const i = a.split(","), e = i.length > 1 ? `one of ${i.join(", ")}` : i[0];
  return {
    code: ot,
    message: `File type must be ${e}`
  };
}, $i = (a) => ({
  code: pt,
  message: `File is larger than ${a} ${a === 1 ? "byte" : "bytes"}`
}), Mi = (a) => ({
  code: rt,
  message: `File is smaller than ${a} ${a === 1 ? "byte" : "bytes"}`
}), st = {
  code: ct,
  message: "Too many files"
};
function Zi(a, i) {
  const e = a.type === "application/x-moz-file" || nt(a, i);
  return [
    e,
    e ? null : lt(i)
  ];
}
function Qi(a, i, e) {
  if (va(a.size))
    if (va(i) && va(e)) {
      if (a.size > e)
        return [!1, $i(e)];
      if (a.size < i)
        return [!1, Mi(i)];
    } else {
      if (va(i) && a.size < i)
        return [!1, Mi(i)];
      if (va(e) && a.size > e)
        return [!1, $i(e)];
    }
  return [!0, null];
}
function va(a) {
  return a != null;
}
function dt({
  files: a,
  accept: i,
  minSize: e,
  maxSize: t,
  multiple: r,
  maxFiles: c,
  validator: s
}) {
  return !r && a.length > 1 || r && c >= 1 && a.length > c ? !1 : a.every((o) => {
    const [g] = Zi(o, i), [w] = Qi(o, e, t), b = s ? s(o) : null;
    return g && w && !b;
  });
}
function qa(a) {
  return typeof a.isPropagationStopped == "function" ? a.isPropagationStopped() : typeof a.cancelBubble != "undefined" ? a.cancelBubble : !1;
}
function Ca(a) {
  return a.dataTransfer ? Array.prototype.some.call(
    a.dataTransfer.types,
    (i) => i === "Files" || i === "application/x-moz-file"
  ) : !!a.target && !!a.target.files;
}
function Wi(a) {
  a.preventDefault();
}
function mt(a) {
  return a.indexOf("MSIE") !== -1 || a.indexOf("Trident/") !== -1;
}
function ut(a) {
  return a.indexOf("Edge/") !== -1;
}
function vt(a = window.navigator.userAgent) {
  return mt(a) || ut(a);
}
function na(...a) {
  return (i, ...e) => a.some((t) => (!qa(i) && t && t(i, ...e), qa(i)));
}
function ft() {
  return "showOpenFilePicker" in window;
}
function xt(a) {
  return va(a) ? [
    {
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: Object.entries(a).filter(([e, t]) => {
        let r = !0;
        return ae(e) || (console.warn(
          `Skipped "${e}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`
        ), r = !1), (!Array.isArray(t) || !t.every(ie)) && (console.warn(
          `Skipped "${e}" because an invalid file extension was provided.`
        ), r = !1), r;
      }).reduce(
        (e, [t, r]) => tt(et({}, e), {
          [t]: r
        }),
        {}
      )
    }
  ] : a;
}
function gt(a) {
  if (va(a))
    return Object.entries(a).reduce((i, [e, t]) => [...i, e, ...t], []).filter((i) => ae(i) || ie(i)).join(",");
}
function ht(a) {
  return a instanceof DOMException && (a.name === "AbortError" || a.code === a.ABORT_ERR);
}
function bt(a) {
  return a instanceof DOMException && (a.name === "SecurityError" || a.code === a.SECURITY_ERR);
}
function ae(a) {
  return a === "audio/*" || a === "video/*" || a === "image/*" || a === "text/*" || a === "application/*" || /\w+\/[-+.\w]+/g.test(a);
}
function ie(a) {
  return /^.*\.[\w]+$/.test(a);
}
var yt = Object.defineProperty, wt = Object.defineProperties, kt = Object.getOwnPropertyDescriptors, Sa = Object.getOwnPropertySymbols, ee = Object.prototype.hasOwnProperty, te = Object.prototype.propertyIsEnumerable, Bi = (a, i, e) => i in a ? yt(a, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[i] = e, U = (a, i) => {
  for (var e in i || (i = {}))
    ee.call(i, e) && Bi(a, e, i[e]);
  if (Sa)
    for (var e of Sa(i))
      te.call(i, e) && Bi(a, e, i[e]);
  return a;
}, ca = (a, i) => wt(a, kt(i)), La = (a, i) => {
  var e = {};
  for (var t in a)
    ee.call(a, t) && i.indexOf(t) < 0 && (e[t] = a[t]);
  if (a != null && Sa)
    for (var t of Sa(a))
      i.indexOf(t) < 0 && te.call(a, t) && (e[t] = a[t]);
  return e;
};
const ri = ve((a, i) => {
  var e = a, { children: t } = e, r = La(e, ["children"]);
  const c = oe(r), { open: s } = c, o = La(c, ["open"]);
  return fe(i, () => ({ open: s }), [s]), /* @__PURE__ */ me.createElement(xe, null, t(ca(U({}, o), { open: s })));
});
ri.displayName = "Dropzone";
const ne = {
  disabled: !1,
  getFilesFromEvent: Be,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
ri.defaultProps = ne;
ri.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: P.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: P.objectOf(P.arrayOf(P.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: P.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: P.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: P.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: P.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: P.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: P.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: P.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: P.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: P.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: P.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: P.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: P.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: P.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: P.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: P.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: P.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: P.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: P.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: P.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: P.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: P.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: P.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: P.func
};
const ii = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function oe(a = {}) {
  const {
    accept: i,
    disabled: e,
    getFilesFromEvent: t,
    maxSize: r,
    minSize: c,
    multiple: s,
    maxFiles: o,
    onDragEnter: g,
    onDragLeave: w,
    onDragOver: b,
    onDrop: f,
    onDropAccepted: F,
    onDropRejected: L,
    onFileDialogCancel: $,
    onFileDialogOpen: E,
    useFsAccessApi: O,
    autoFocus: R,
    preventDropOnDocument: Y,
    noClick: G,
    noKeyboard: T,
    noDrag: N,
    noDragEventsBubbling: W,
    onError: V,
    validator: X
  } = U(U({}, ne), a), Z = ha(() => gt(i), [i]), oa = ha(() => xt(i), [i]), K = ha(
    () => typeof E == "function" ? E : Ni,
    [E]
  ), aa = ha(
    () => typeof $ == "function" ? $ : Ni,
    [$]
  ), C = _a(null), S = _a(null), [xa, _] = ue(jt, ii), { isFocused: pa, isFileDialogActive: sa } = xa, ra = _a(
    typeof window != "undefined" && window.isSecureContext && O && ft()
  ), n = () => {
    !ra.current && sa && setTimeout(() => {
      if (S.current) {
        const { files: l } = S.current;
        l.length || (_({ type: "closeDialog" }), aa());
      }
    }, 300);
  };
  ya(() => (window.addEventListener("focus", n, !1), () => {
    window.removeEventListener("focus", n, !1);
  }), [S, sa, aa, ra]);
  const p = _a([]), h = (l) => {
    C.current && C.current.contains(l.target) || (l.preventDefault(), p.current = []);
  };
  ya(() => (Y && (document.addEventListener("dragover", Wi, !1), document.addEventListener("drop", h, !1)), () => {
    Y && (document.removeEventListener("dragover", Wi), document.removeEventListener("drop", h));
  }), [C, Y]), ya(() => (!e && R && C.current && C.current.focus(), () => {
  }), [C, R, e]);
  const m = Q(
    (l) => {
      V ? V(l) : console.error(l);
    },
    [V]
  ), u = Q(
    (l) => {
      l.preventDefault(), l.persist(), ua(l), p.current = [...p.current, l.target], Ca(l) && Promise.resolve(t(l)).then((z) => {
        if (qa(l) && !W)
          return;
        const q = z.length, M = q > 0 && dt({
          files: z,
          accept: Z,
          minSize: c,
          maxSize: r,
          multiple: s,
          maxFiles: o,
          validator: X
        }), J = q > 0 && !M;
        _({
          isDragAccept: M,
          isDragReject: J,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), g && g(l);
      }).catch((z) => m(z));
    },
    [
      t,
      g,
      m,
      W,
      Z,
      c,
      r,
      s,
      o,
      X
    ]
  ), j = Q(
    (l) => {
      l.preventDefault(), l.persist(), ua(l);
      const z = Ca(l);
      if (z && l.dataTransfer)
        try {
          l.dataTransfer.dropEffect = "copy";
        } catch (q) {
        }
      return z && b && b(l), !1;
    },
    [b, W]
  ), x = Q(
    (l) => {
      l.preventDefault(), l.persist(), ua(l);
      const z = p.current.filter(
        (M) => C.current && C.current.contains(M)
      ), q = z.indexOf(l.target);
      q !== -1 && z.splice(q, 1), p.current = z, !(z.length > 0) && (_({
        type: "setDraggedFiles",
        isDragActive: !1,
        isDragAccept: !1,
        isDragReject: !1
      }), Ca(l) && w && w(l));
    },
    [C, w, W]
  ), v = Q(
    (l, z) => {
      const q = [], M = [];
      l.forEach((J) => {
        const [ka, ja] = Zi(J, Z), [Ba, Na] = Qi(J, c, r), Da = X ? X(J) : null;
        if (ka && Ba && !Da)
          q.push(J);
        else {
          let za = [ja, Na];
          Da && (za = za.concat(Da)), M.push({ file: J, errors: za.filter((Ka) => Ka) });
        }
      }), (!s && q.length > 1 || s && o >= 1 && q.length > o) && (q.forEach((J) => {
        M.push({ file: J, errors: [st] });
      }), q.splice(0)), _({
        acceptedFiles: q,
        fileRejections: M,
        isDragReject: M.length > 0,
        type: "setFiles"
      }), f && f(q, M, z), M.length > 0 && L && L(M, z), q.length > 0 && F && F(q, z);
    },
    [
      _,
      s,
      Z,
      c,
      r,
      o,
      f,
      F,
      L,
      X
    ]
  ), y = Q(
    (l) => {
      l.preventDefault(), l.persist(), ua(l), p.current = [], Ca(l) && Promise.resolve(t(l)).then((z) => {
        qa(l) && !W || v(z, l);
      }).catch((z) => m(z)), _({ type: "reset" });
    },
    [t, v, m, W]
  ), k = Q(() => {
    if (ra.current) {
      _({ type: "openDialog" }), K();
      const l = {
        multiple: s,
        types: oa
      };
      window.showOpenFilePicker(l).then((z) => t(z)).then((z) => {
        v(z, null), _({ type: "closeDialog" });
      }).catch((z) => {
        ht(z) ? (aa(z), _({ type: "closeDialog" })) : bt(z) ? (ra.current = !1, S.current ? (S.current.value = null, S.current.click()) : m(
          new Error(
            "Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."
          )
        )) : m(z);
      });
      return;
    }
    S.current && (_({ type: "openDialog" }), K(), S.current.value = null, S.current.click());
  }, [
    _,
    K,
    aa,
    O,
    v,
    m,
    oa,
    s
  ]), D = Q(
    (l) => {
      !C.current || !C.current.isEqualNode(l.target) || (l.key === " " || l.key === "Enter" || l.keyCode === 32 || l.keyCode === 13) && (l.preventDefault(), k());
    },
    [C, k]
  ), B = Q(() => {
    _({ type: "focus" });
  }, []), I = Q(() => {
    _({ type: "blur" });
  }, []), ia = Q(() => {
    G || (vt() ? setTimeout(k, 0) : k());
  }, [G, k]), ta = (l) => e ? null : l, da = (l) => T ? null : ta(l), ma = (l) => N ? null : ta(l), ua = (l) => {
    W && l.stopPropagation();
  }, Ma = ha(
    () => (l = {}) => {
      var z = l, {
        refKey: q = "ref",
        role: M,
        onKeyDown: J,
        onFocus: ka,
        onBlur: ja,
        onClick: Ba,
        onDragEnter: Na,
        onDragOver: Da,
        onDragLeave: za,
        onDrop: Ka
      } = z, re = La(z, [
        "refKey",
        "role",
        "onKeyDown",
        "onFocus",
        "onBlur",
        "onClick",
        "onDragEnter",
        "onDragOver",
        "onDragLeave",
        "onDrop"
      ]);
      return U(U({
        onKeyDown: da(
          na(J, D)
        ),
        onFocus: da(
          na(ka, B)
        ),
        onBlur: da(na(ja, I)),
        onClick: ta(na(Ba, ia)),
        onDragEnter: ma(
          na(Na, u)
        ),
        onDragOver: ma(
          na(Da, j)
        ),
        onDragLeave: ma(
          na(za, x)
        ),
        onDrop: ma(na(Ka, y)),
        role: typeof M == "string" && M !== "" ? M : "presentation",
        [q]: C
      }, !e && !T ? { tabIndex: 0 } : {}), re);
    },
    [
      C,
      D,
      B,
      I,
      ia,
      u,
      j,
      x,
      y,
      T,
      N,
      e
    ]
  ), Wa = Q((l) => {
    l.stopPropagation();
  }, []), pe = ha(
    () => (l = {}) => {
      var z = l, { refKey: q = "ref", onChange: M, onClick: J } = z, ka = La(z, ["refKey", "onChange", "onClick"]);
      const ja = {
        accept: Z,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: ta(na(M, y)),
        onClick: ta(
          na(J, Wa)
        ),
        tabIndex: -1,
        [q]: S
      };
      return U(U({}, ja), ka);
    },
    [S, i, s, y, e]
  );
  return ca(U({}, xa), {
    isFocused: pa && !e,
    getRootProps: Ma,
    getInputProps: pe,
    rootRef: C,
    inputRef: S,
    open: ta(k)
  });
}
function jt(a, i) {
  switch (i.type) {
    case "focus":
      return ca(U({}, a), {
        isFocused: !0
      });
    case "blur":
      return ca(U({}, a), {
        isFocused: !1
      });
    case "openDialog":
      return ca(U({}, ii), {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return ca(U({}, a), {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return ca(U({}, a), {
        isDragActive: i.isDragActive,
        isDragAccept: i.isDragAccept,
        isDragReject: i.isDragReject
      });
    case "setFiles":
      return ca(U({}, a), {
        acceptedFiles: i.acceptedFiles,
        fileRejections: i.fileRejections,
        isDragReject: i.isDragReject
      });
    case "reset":
      return U({}, ii);
    default:
      return a;
  }
}
function Ni() {
}
const [Dt, zt] = be(
  "Dropzone component was not found in tree"
);
function ci(a) {
  const i = (e) => {
    const o = $a(`Dropzone${zi(a)}`, {}, e), { children: t } = o, r = ga(o, ["children"]), c = zt(), s = we(t) ? t : /* @__PURE__ */ d("span", { children: t });
    return c[a] ? ge(s, r) : null;
  };
  return i.displayName = `@mantine/dropzone/${zi(a)}`, i;
}
const Et = ci("accept"), Ot = ci("reject"), Ft = ci("idle");
var Fa = { root: "m_d46a4834", inner: "m_b85f7144", fullScreen: "m_96f6e9ad", dropzone: "m_7946116d" };
const Pt = {
  loading: !1,
  multiple: !0,
  maxSize: 1 / 0,
  autoFocus: !1,
  activateOnClick: !0,
  activateOnDrag: !0,
  dragEventsBubbling: !0,
  activateOnKeyboard: !0,
  useFsAccessApi: !0,
  variant: "light",
  rejectColor: "red"
}, _t = Yi(
  (a, { radius: i, variant: e, acceptColor: t, rejectColor: r }) => {
    const c = a.variantColorResolver({
      color: t || a.primaryColor,
      theme: a,
      variant: e
    }), s = a.variantColorResolver({
      color: r || "red",
      theme: a,
      variant: e
    });
    return {
      root: {
        "--dropzone-radius": Ee(i),
        "--dropzone-accept-color": c.color,
        "--dropzone-accept-bg": c.background,
        "--dropzone-reject-color": s.color,
        "--dropzone-reject-bg": s.background
      }
    };
  }
), la = ei((a, i) => {
  const e = $a("Dropzone", Pt, a), ua = e, {
    classNames: t,
    className: r,
    style: c,
    styles: s,
    unstyled: o,
    vars: g,
    radius: w,
    disabled: b,
    loading: f,
    multiple: F,
    maxSize: L,
    accept: $,
    children: E,
    onDropAny: O,
    onDrop: R,
    onReject: Y,
    openRef: G,
    name: T,
    maxFiles: N,
    autoFocus: W,
    activateOnClick: V,
    activateOnDrag: X,
    dragEventsBubbling: Z,
    activateOnKeyboard: oa,
    onDragEnter: K,
    onDragLeave: aa,
    onDragOver: C,
    onFileDialogCancel: S,
    onFileDialogOpen: xa,
    preventDropOnDocument: _,
    useFsAccessApi: pa,
    getFilesFromEvent: sa,
    validator: ra,
    rejectColor: n,
    acceptColor: p,
    enablePointerEvents: h,
    loaderProps: m,
    inputProps: u,
    mod: j
  } = ua, x = ga(ua, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "radius",
    "disabled",
    "loading",
    "multiple",
    "maxSize",
    "accept",
    "children",
    "onDropAny",
    "onDrop",
    "onReject",
    "openRef",
    "name",
    "maxFiles",
    "autoFocus",
    "activateOnClick",
    "activateOnDrag",
    "dragEventsBubbling",
    "activateOnKeyboard",
    "onDragEnter",
    "onDragLeave",
    "onDragOver",
    "onFileDialogCancel",
    "onFileDialogOpen",
    "preventDropOnDocument",
    "useFsAccessApi",
    "getFilesFromEvent",
    "validator",
    "rejectColor",
    "acceptColor",
    "enablePointerEvents",
    "loaderProps",
    "inputProps",
    "mod"
  ]), v = ni({
    name: "Dropzone",
    classes: Fa,
    props: e,
    className: r,
    style: c,
    classNames: t,
    styles: s,
    unstyled: o,
    vars: g,
    varsResolver: _t
  }), { getRootProps: y, getInputProps: k, isDragAccept: D, isDragReject: B, isDragActive: I, open: ia } = oe(A({
    onDrop: O,
    onDropAccepted: R,
    onDropRejected: Y,
    disabled: b || f,
    accept: Array.isArray($) ? $.reduce((Ma, Wa) => H(A({}, Ma), { [Wa]: [] }), {}) : $,
    multiple: F,
    maxSize: L,
    maxFiles: N,
    autoFocus: W,
    noClick: !V,
    noDrag: !X,
    noDragEventsBubbling: !Z,
    noKeyboard: !oa,
    onDragEnter: K,
    onDragLeave: aa,
    onDragOver: C,
    onFileDialogCancel: S,
    onFileDialogOpen: xa,
    preventDropOnDocument: _,
    useFsAccessApi: pa,
    validator: ra
  }, sa ? { getFilesFromEvent: sa } : null));
  ke(G, ia);
  const ta = I && D, da = I && B, ma = !ta && !da;
  return /* @__PURE__ */ d(Dt, { value: { accept: ta, reject: da, idle: ma }, children: /* @__PURE__ */ ea(
    ti,
    H(A(A(A({}, y()), v("root", { focusable: !0 })), x), {
      mod: [
        {
          accept: ta,
          reject: da,
          idle: ma,
          disabled: b,
          loading: f,
          "activate-on-click": V
        },
        j
      ],
      children: [
        /* @__PURE__ */ d(
          oi,
          {
            visible: f,
            overlayProps: { radius: w },
            unstyled: o,
            loaderProps: m
          }
        ),
        /* @__PURE__ */ d("input", H(A({}, k(u)), { name: T })),
        /* @__PURE__ */ d(
          "div",
          H(A({}, v("inner")), {
            ref: i,
            "data-enable-pointer-events": h || void 0,
            children: E
          })
        )
      ]
    })
  ) });
});
la.classes = Fa;
la.displayName = "@mantine/dropzone/Dropzone";
la.Accept = Et;
la.Idle = Ft;
la.Reject = Ot;
const Tt = {
  loading: !1,
  maxSize: 1 / 0,
  activateOnClick: !1,
  activateOnDrag: !0,
  dragEventsBubbling: !0,
  activateOnKeyboard: !0,
  active: !0,
  zIndex: Ui("max"),
  withinPortal: !0
}, li = ei((a, i) => {
  const e = $a("DropzoneFullScreen", Tt, a), oa = e, {
    classNames: t,
    className: r,
    style: c,
    styles: s,
    unstyled: o,
    vars: g,
    active: w,
    onDrop: b,
    onReject: f,
    zIndex: F,
    withinPortal: L,
    portalProps: $
  } = oa, E = ga(oa, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "active",
    "onDrop",
    "onReject",
    "zIndex",
    "withinPortal",
    "portalProps"
  ]), O = ni({
    name: "DropzoneFullScreen",
    classes: Fa,
    props: e,
    className: r,
    style: c,
    classNames: t,
    styles: s,
    unstyled: o,
    rootSelector: "fullScreen"
  }), { resolvedClassNames: R, resolvedStyles: Y } = Oe({
    classNames: t,
    styles: s,
    props: e
  }), [G, T] = Ki(0), [N, { open: W, close: V }] = Fe(!1), X = (K) => {
    var aa;
    (aa = K.dataTransfer) != null && aa.types.includes("Files") && (T((C) => C + 1), W());
  }, Z = () => {
    T((K) => K - 1);
  };
  return ya(() => {
    G === 0 && V();
  }, [G]), ya(() => {
    if (w)
      return document.addEventListener("dragenter", X, !1), document.addEventListener("dragleave", Z, !1), () => {
        document.removeEventListener("dragenter", X, !1), document.removeEventListener("dragleave", Z, !1);
      };
  }, [w]), /* @__PURE__ */ d(je, H(A({}, $), { withinPortal: L, children: /* @__PURE__ */ d(
    ti,
    H(A({}, O("fullScreen", {
      style: { opacity: N ? 1 : 0, pointerEvents: N ? "all" : "none", zIndex: F }
    })), {
      ref: i,
      children: /* @__PURE__ */ d(
        la,
        H(A({}, E), {
          classNames: R,
          styles: Y,
          unstyled: o,
          className: Fa.dropzone,
          onDrop: (K) => {
            b == null || b(K), V(), T(0);
          },
          onReject: (K) => {
            f == null || f(K), V(), T(0);
          }
        })
      )
    })
  ) }));
});
li.classes = Fa;
li.displayName = "@mantine/dropzone/DropzoneFullScreen";
la.FullScreen = li;
const Ra = la, At = "FileDropzone-module__root___bl8ys", Ct = "FileDropzone-module__buttonVariant___9Tn-p", Rt = "FileDropzone-module__uploadedFile___dEeVO", It = "FileDropzone-module__uploadedFileName___8pXAd", qt = "FileDropzone-module__uploadedFilesContainer___UkNMk", Oa = {
  root: At,
  buttonVariant: Ct,
  uploadedFile: Rt,
  uploadedFileName: It,
  uploadedFilesContainer: qt
}, St = (a) => {
  const i = a.type.toLowerCase(), t = a.name.toLowerCase().split(".").pop() || "";
  if (i.includes("pdf"))
    return /* @__PURE__ */ d(fi, { color: "var(--plum-violet-5)" });
  if (i.includes("image"))
    return /* @__PURE__ */ d(xi, { color: "var(--plum-violet-5)" });
  if (i.includes("audio"))
    return /* @__PURE__ */ d(gi, { color: "var(--plum-violet-5)" });
  if (i.includes("video"))
    return /* @__PURE__ */ d(hi, { color: "var(--plum-violet-5)" });
  if (i.includes("zip") || i.includes("compressed") || i.includes("archive"))
    return /* @__PURE__ */ d(bi, { color: "var(--plum-violet-5)" });
  if (i.includes("msword") || i.includes("wordprocessingml"))
    return /* @__PURE__ */ d(yi, { color: "var(--plum-violet-5)" });
  if (i.includes("spreadsheetml") || i.includes("excel"))
    return /* @__PURE__ */ d(wi, { color: "var(--plum-violet-5)" });
  if (i.includes("presentationml") || i.includes("powerpoint"))
    return /* @__PURE__ */ d(ki, { color: "var(--plum-violet-5)" });
  if (i.includes("text/html") || i.includes("javascript") || i.includes("css"))
    return /* @__PURE__ */ d(ji, { color: "var(--plum-violet-5)" });
  switch (t) {
    case "pdf":
      return /* @__PURE__ */ d(fi, { color: "var(--plum-violet-5)" });
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "svg":
    case "webp":
      return /* @__PURE__ */ d(xi, { color: "var(--plum-violet-5)" });
    case "doc":
    case "docx":
      return /* @__PURE__ */ d(yi, { color: "var(--plum-violet-5)" });
    case "xls":
    case "xlsx":
    case "csv":
      return /* @__PURE__ */ d(wi, { color: "var(--plum-violet-5)" });
    case "ppt":
    case "pptx":
      return /* @__PURE__ */ d(ki, { color: "var(--plum-violet-5)" });
    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
      return /* @__PURE__ */ d(bi, { color: "var(--plum-violet-5)" });
    case "mp3":
    case "wav":
    case "ogg":
    case "flac":
      return /* @__PURE__ */ d(gi, { color: "var(--plum-violet-5)" });
    case "mp4":
    case "mov":
    case "avi":
    case "webm":
    case "mkv":
      return /* @__PURE__ */ d(hi, { color: "var(--plum-violet-5)" });
    case "html":
    case "css":
    case "js":
    case "jsx":
    case "ts":
    case "tsx":
    case "json":
    case "xml":
    case "php":
    case "py":
      return /* @__PURE__ */ d(ji, { color: "var(--plum-violet-5)" });
    default:
      return /* @__PURE__ */ d(_e, { color: "var(--plum-violet-5)" });
  }
};
function Lt(L) {
  var $ = L, {
    className: a,
    accept: i,
    maxSize: e = 5 * ui(1024, 2),
    description: t,
    title: r,
    buttonVariant: c = !1,
    initialFiles: s = [],
    loadingFiles: o = [],
    loading: g = !1,
    progressValue: w = 0,
    onDrop: b = () => {
    },
    onRemove: f
  } = $, F = ga($, [
    "className",
    "accept",
    "maxSize",
    // 5MB default
    "description",
    "title",
    "buttonVariant",
    "initialFiles",
    "loadingFiles",
    "loading",
    "progressValue",
    "onDrop",
    "onRemove"
  ]);
  const [E, O] = Ki(s);
  ya(() => {
    O(s);
  }, [s]);
  const R = (T) => {
    O((N) => [...N, ...T]), b(T);
  }, Y = (T) => {
    O((N) => N.filter((W, V) => V !== T)), f == null || f(T);
  }, G = c ? /* @__PURE__ */ d(Ua, { align: "center", justify: "flex-start", children: /* @__PURE__ */ d(
    Di,
    {
      variant: "secondary",
      leftSection: /* @__PURE__ */ d(Ta, {}),
      loading: g,
      children: r || "Upload files"
    }
  ) }) : /* @__PURE__ */ d(Te, { justify: "center", gap: "xl", children: g ? /* @__PURE__ */ ea(ba, { align: "center", gap: "md", py: "md", children: [
    /* @__PURE__ */ d(Ha, { size: "md", color: "violet" }),
    w > 0 && /* @__PURE__ */ d(Ha, { variant: "linear", value: w, color: "violet", style: { width: "80%" } }),
    /* @__PURE__ */ d(Ea, { size: "sm", c: "gray.7", children: "Processing files..." })
  ] }) : /* @__PURE__ */ ea(de, { children: [
    /* @__PURE__ */ ea(Ua, { children: [
      /* @__PURE__ */ d(Ra.Accept, { children: /* @__PURE__ */ d(Ta, {}) }),
      /* @__PURE__ */ d(Ra.Reject, { children: /* @__PURE__ */ d(Ta, {}) }),
      /* @__PURE__ */ d(Ra.Idle, { children: /* @__PURE__ */ d(Ta, {}) })
    ] }),
    /* @__PURE__ */ ea("div", { children: [
      /* @__PURE__ */ d(Ea, { size: "md", fw: 500, c: "gray.9", inline: !0, children: r || "Drag files here or click to select files" }),
      /* @__PURE__ */ d(Ea, { size: "xs", c: "gray.7", mt: 7, children: t || `Files should not exceed ${Math.round(e / 1024 / 1024)}MB` })
    ] })
  ] }) });
  return /* @__PURE__ */ ea(ba, { gap: "md", children: [
    /* @__PURE__ */ d(
      Ra,
      H(A({
        className: c ? `${Oa.buttonVariant} ${a || ""}` : a,
        accept: i,
        maxSize: e,
        classNames: Oa,
        onDrop: R,
        disabled: g
      }, F), {
        children: G
      })
    ),
    E.length > 0 && /* @__PURE__ */ d(ba, { children: /* @__PURE__ */ d(ba, { gap: "xs", className: Oa.uploadedFilesContainer, children: E.map((T, N) => {
      const W = o.includes(T.id);
      return /* @__PURE__ */ ea(Ua, { className: Oa.uploadedFile, children: [
        /* @__PURE__ */ ea(ba, { align: "flex-start", gap: "md", w: "100%", children: [
          W ? /* @__PURE__ */ d(Ha, { size: "sm", color: "violet" }) : St(T),
          /* @__PURE__ */ ea(ba, { gap: 0, w: "100%", children: [
            /* @__PURE__ */ d(Ea, { size: "sm", fw: 500, c: "gray.9", className: Oa.uploadedFileName, children: T.name }),
            /* @__PURE__ */ ea(Ea, { size: "xs", c: "gray.7", children: [
              Math.round(T.size / 1024),
              " ",
              "KB"
            ] })
          ] })
        ] }),
        /* @__PURE__ */ d(
          Di,
          {
            variant: "tertiary",
            size: "sm",
            onClick: () => Y(N),
            "aria-label": "Remove file",
            disabled: W,
            children: /* @__PURE__ */ d(Pe, {})
          }
        )
      ] }, N);
    }) }) })
  ] });
}
Lt.displayName = "FileDropzone";
export {
  Lt as FileDropzone
};
